import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetAllSampleCards(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/samplecards`);
}

export function apiGetSampleCardsForProduct(
  productId: number,
  onlySpecialReceipts:boolean,
  onlyCustomReceipts:boolean
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/samplecardsforproduct/${productId}/${onlySpecialReceipts}/${onlyCustomReceipts}`);
}

export function apiGetSampleCardDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/samplecard/${id}`);
}

export function apiSampleCardCreateOrUpdate(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/samplecardcreateorupdate`, data);
}

export function apiDeleteSampleCard(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/samplecard/${id}`);
}
